/* eslint-disable global-require */
import carousel from './components/carousel/_carousel';
import accordion from './components/accordion/_accordion';
import videoModal from './components/videos/_videoModal';
import anchors from './navigation/anchors';
import bodyBackground from './global/_bodyBackground';
import mainNav from './navigation/navigation';
import mobileHeaderNav from './navigation/mobile-nav';
import homePage from './pages/_home';
import careersPage from './pages/_careers';
import servicesPage from './pages/_services';
import locationsLanding from './pages/_locationsLanding';
import videoPlayer from './components/videos/_videoPlayer';
// import acfMap from './acf/_acf-map';

const Site = () => {

    document.addEventListener("DOMContentLoaded", function () {
        let node = document.querySelector('.preload-transitions');
        node.classList.remove('preload-transitions');
    });

    function mfReady(callbackFunc) {
        if (document.readyState !== 'loading') {
            // Document is already ready, call the callback directly
            callbackFunc();
        } else if (document.addEventListener) {
            // All modern browsers to register DOMContentLoaded
            document.addEventListener('DOMContentLoaded', callbackFunc);
        } else {
            // Old IE browsers
            document.attachEvent('onreadystatechange', () => {
                if (document.readyState === 'complete') {
                    callbackFunc();
                }
            });
        }
    }

    mfReady(() => {

        

        // anchors
        anchors();

        // Body Background Change
        bodyBackground();

        // Main header nav
        mainNav();

        // Mobile Navigation Set-up
        mobileHeaderNav();

        // Home Page
        homePage();

        // Careers Page
        careersPage();

        // Services Page
        servicesPage();

        // Location Landing
        locationsLanding();

        // Blog Single
        videoPlayer();

        // Video Modal
        videoModal();

        // Initialize Slick Carousels
        carousel();

        // Initialize Accordion
        accordion();

        // ACF Google map
        // acfMap();

    });
};

export default Site;
